var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon__remain__ticket"},[_c('icon-ticket',{attrs:{"color":_vm.iconColor}}),_c('p',[_vm._v("残り: "+_vm._s(_vm.count))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }